export const state = {
  requisitions: [],
  transportertrucks: [],
  transporter: [],
  systemRequisition: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/requisitions/state.js